<script lang="ts">
  export let errors: number;
</script>

<div
  class="bg-[#24283a] border border-white/10 rounded-xl p-6"
>
  <h3
    class="text-[1.125rem] font-bold text-white mb-4 uppercase tracking-[0.5px]"
  >
    Conflict & Error Summary
  </h3>
  <div class="grid gap-4">
    <div
      class="flex justify-between items-center p-5 bg-black/20 border-l-[3px] border-amber-500 rounded-lg transition-all hover:bg-black/30 hover:translate-x-[2px]"
    >
      <div class="flex flex-col gap-1">
        <span class="text-white font-semibold text-[0.938rem]">
          Stage mismatches
        </span>
        <span class="text-white/60 text-[0.813rem]">
          Opportunities with different lifecycle stages
        </span>
      </div>
      <span
        class="text-white font-bold text-2xl px-4 py-2 bg-white/10 rounded-lg border-2 border-white/20"
      >
        0
      </span>
    </div>
    <div
      class="flex justify-between items-center p-5 bg-black/20 border-l-[3px] border-amber-500 rounded-lg transition-all hover:bg-black/30 hover:translate-x-[2px]"
    >
      <div class="flex flex-col gap-1">
        <span class="text-white font-semibold text-[0.938rem]">
          Value mismatches
        </span>
        <span class="text-white/60 text-[0.813rem]">
          Discrepancies in opportunity values
        </span>
      </div>
      <span
        class="text-white font-bold text-2xl px-4 py-2 bg-white/10 rounded-lg border-2 border-white/20"
      >
        0
      </span>
    </div>
    <div
      class="flex justify-between items-center p-5 bg-black/20 border-l-[3px] border-amber-500 rounded-lg transition-all hover:bg-black/30 hover:translate-x-[2px]"
    >
      <div class="flex flex-col gap-1">
        <span class="text-white font-semibold text-[0.938rem]">
          Owner mismatches
        </span>
        <span class="text-white/60 text-[0.813rem]">
          Different owners between systems
        </span>
      </div>
      <span
        class="text-white font-bold text-2xl px-4 py-2 bg-white/10 rounded-lg border-2 border-white/20"
      >
        0
      </span>
    </div>
    <div
      class="flex justify-between items-center p-5 bg-black/20 border-l-[3px] border-amber-500 rounded-lg transition-all hover:bg-black/30 hover:translate-x-[2px]"
    >
      <div class="flex flex-col gap-1">
        <span class="text-white font-semibold text-[0.938rem]">
          Deleted in one system
        </span>
        <span class="text-white/60 text-[0.813rem]">
          Records missing from one system
        </span>
      </div>
      <span
        class="text-white font-bold text-2xl px-4 py-2 bg-white/10 rounded-lg border-2 border-white/20"
      >
        0
      </span>
    </div>
    <div
      class="flex justify-between items-center p-5 rounded-lg transition-all hover:translate-x-[2px] bg-red-500/15 border-l-[3px] border-red-500"
    >
      <div class="flex flex-col gap-1">
        <span class="text-white font-semibold text-[0.938rem]">
          API / Validation errors
        </span>
        <span class="text-white/60 text-[0.813rem]">
          Sync failures and validation issues
        </span>
      </div>
      <span
        class="text-red-500 font-bold text-2xl px-4 py-2 bg-red-500/10 rounded-lg border-2 border-red-500/50"
      >
        {errors}
      </span>
    </div>
  </div>
</div>
